// Match the existing grid's two controls; never force a crop for a product
// whose merchant has chosen to keep the whole photograph visible.
export const productImageFit = (product = {}, settings = {}) =>
  product.stretch_photo
    ? settings.fit_images_to_div ? "fill" : "cover"
    : "contain";

export const categoryImageFit = (settings = {}) =>
  settings.fit_images_to_div ? "fill" : "cover";
